var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('div',[_c('div',[_vm._v(_vm._s(_vm.item.user_name)+" ("+_vm._s(_vm.organization)+") | "+_vm._s(_vm.item.biz_name))]),_c('div',[_vm._v(_vm._s(_vm.fromNow)+" | last updated "+_vm._s(_vm._f("datetime")(_vm.item.updated,"smart")))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }